export default function hasEmptySpeaker(segments) {
  return segments.some((segment) => segment.speaker === "");
}